import { render, staticRenderFns } from "./DashGlosas.vue?vue&type=template&id=3b3c99f6&"
import script from "./DashGlosas.vue?vue&type=script&lang=js&"
export * from "./DashGlosas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports